import serviceTwo from './serviceTwo';

export const templateList = async () => {
  const response = await serviceTwo.getTwo(`/templates/list`);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const removeTemplate = async (payload) => {
  const response = await serviceTwo.postTwo(`/templates/delete`, payload);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const createTemplate = async (payload) => {
  const response = await serviceTwo.postTwo(`/templates/create`, payload);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const updateTemplate = async (payload) => {
  const response = await serviceTwo.postTwo(`/templates/update`, payload);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const getTemplate = async (payload) => {
  const response = await serviceTwo.postTwo(`/templates/get`, payload);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};
